import { getData, saveData } from "../localStorage/LocalStorageHandler";

export const NOTIFICATION_SOUND_KEY = "EnableNotificationSound";

let notificationAudioContext = null;

const getAudioContext = () => {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext) return null;

  if (!notificationAudioContext) {
    notificationAudioContext = new AudioContext();
  }

  return notificationAudioContext;
};

export const isNotificationSoundEnabled = () =>
  Boolean(getData(NOTIFICATION_SOUND_KEY));

export const setNotificationSoundPreference = (isEnabled) => {
  saveData(NOTIFICATION_SOUND_KEY, Boolean(isEnabled));
};

export const unlockNotificationSound = async () => {
  try {
    const audioContext = getAudioContext();
    if (!audioContext) return;

    if (audioContext.state === "suspended") {
      await audioContext.resume();
    }
  } catch (error) {
    console.warn("[Notification Sound] Unable to unlock sound.", error);
  }
};

export const playNotificationSound = async () => {
  if (!isNotificationSoundEnabled()) return;

  try {
    await unlockNotificationSound();

    const audio = new Audio("/sounds/notification-sound.wav");
    audio.volume = 0.7;
    await audio.play();
  } catch (error) {
    console.warn("[Notification Sound] Unable to play sound.", error);
  }
};
